import { render } from "./title-and-type.vue?vue&type=template&id=6c4296bc"
import script from "./title-and-type.vue?vue&type=script&lang=js"
export * from "./title-and-type.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__